import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import '../../../style/cargainventario.css';
import apiService from '../../../actions/services';
import * as Utils from '../../../utils/tools';

function CargaInventario() {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [fileName, setFileName] = useState('');
  const [isDragOver, setIsDragOver] = useState(false);
  const [bitacora, setBitacora] = useState([]);
  const [tiendas, setTiendas] = useState([]);
  const { token, user } = useSelector(state => state.auth);
  const [SalaSeleccionada, setSalaSeleccionada] = useState('');

  // Simular datos de bitácora (en una aplicación real, estos vendrían de una API)
  useEffect(() => {
    if (user.usuario == "TZ10") {
      console.log("entro")
      setTiendas(["TZ10"]);
    } else if (user.usuario == "TPRR") {
      setTiendas(["TPRR"]);
    } else if (user.usuario == "TSCR") {
      setTiendas(["TSCR"]);

    } else if (user.usuario == "TCSV") {
      setTiendas(["TCSV"]);

    } else if (user.usuario == "TXLA") {
      setTiendas(["TXLA"]);

    } else if (user.usuario == "TMIR") {
      setTiendas(["TMIR"]);
    } else {
      setTiendas(["TZ10", "TPRR", "TXLA", "TMIR", "TSCR", "TCSV"]);
    }
    console.log("Tiendas : ", tiendas);
    fetchData();
  }, []);

  const fetchData = async () => {
    var SAL = { "SALA": user.user };
    console.log(user);
    if (user.usuario.length > 5) {
      SAL = {};
      console.log("Usuario Administrativo mayor a 5 letras ");
    }
    else {
      SAL = { "SALA": user.user };
      console.log("Usuario Salas");
    }


    const ejemploBitacora = await apiService.get("SalasInventarios_Bitacora", SAL);
    console.log(JSON.parse(ejemploBitacora.datos_Generados));
    setBitacora(JSON.parse(ejemploBitacora.datos_Generados));
  };

  const handleFile = (file) => {
    setMessage('');
    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length > 0) {
          setHeaders(jsonData[0]);
          // Filtrar filas vacías
          const filteredData = jsonData.slice(1).filter(row => row.some(cell => cell !== ''));
          setData(filteredData);
          setMessage(`Archivo "${file.name}" cargado correctamente. Revise los datos antes de continuar.`);
        } else {
          setMessage('El archivo está vacío');
        }
      } catch (error) {
        setMessage('Error al procesar el archivo: ' + error.message);
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];

      // Verificar que es un archivo Excel
      const validExtensions = ['.xls', '.xlsx'];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      if (validExtensions.includes(fileExtension)) {
        handleFile(file);
      } else {
        setMessage('Por favor, sube un archivo Excel válido (.xls o .xlsx)');
      }
    }
  };

  const handleFileSelect = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      handleFile(e.target.files[0]);
    }
  };
  const datosParaExcel = (datosEjemplo) => {
    console.log("AQUI 4", datosEjemplo);
    const headers = Object.keys(datosEjemplo[0]);
    console.log("AQUI 5", headers);
    const dataArray = datosEjemplo.map(item =>
      headers.map(header => item[header])
    );
    console.log("AQUI 6", dataArray);
    return [headers, ...dataArray];
  };

  const descargarPlantilla = async () => {
    // Crear datos de ejemplo para la plantilla
    const jinterno = { "Vista": "ListaProductosInventariables" };
    const Dat = await apiService.get("ListaReportesSalas", jinterno);
    const datosEjemplo = JSON.parse(Dat.datos_Generados);
    //console.log("AQUI 1:", datosEjemplo);
    const datosParaExcel = [
      ["ITEMCODE", "ITEMNAME", "Existencia"],
      ...datosEjemplo.map(item => [item.ITEMCODE, item.ITEMNAME, item.Existencia])
    ];
    const datExcel = datosParaExcel; //datosParaExcel(JSON.stringify(datosEjemplo));
    //console.log("AQUI 2:", datExcel);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(datExcel);
    XLSX.utils.book_append_sheet(wb, ws, 'Plantilla Inventario');
    const NombreArchivo = generarNombreArchivo();
    XLSX.writeFile(wb, NombreArchivo);
  };
  const generarNombreArchivo = () => {
    const ahora = new Date();
    const offset = -6; // GMT-6
    const fechaGMT6 = new Date(ahora.getTime() + offset * 60 * 60 * 1000);
    const año = fechaGMT6.getUTCFullYear();
    const mes = String(fechaGMT6.getUTCMonth() + 1).padStart(2, '0');
    const dia = String(fechaGMT6.getUTCDate()).padStart(2, '0');
    return `plantilla_inventario_[${año}-${mes}-${dia}].xls`;
  };

  const handleUpload = async () => {
    if (data.length === 0) {
      setMessage('No hay datos para cargar');
      return;
    }
    setLoading(true);
    setMessage('Cargando inventario...');

    try {
      //console.log(data);
      const elementosNoVacios = data.filter(item => item[2] !== "");
      //console.log(elementosNoVacios);

      const Jexistencias = elementosNoVacios.map(item => {
        return {
          CodigoProducto: item[0] || "",
          NombreProducto: item[1] || "",
          Existencia: item[2] || ""
        };
      });
      var Sala = user.usuario;
      if (Sala.length >= 6) {
        if (SalaSeleccionada.length === 0) {
          //setMessage('Error: Sala no seleccionada cargar');
          setMessage('Error: Se debe de seleccionar una sala para continuar...');
          setLoading(false);
          return;
        }
        Sala = SalaSeleccionada;
        console.log("Sala Seleccionada : ", Sala);
      }

      const JCarga = { "SALA": Sala, "Usuario": user.usuario, "GuideCarga": Utils.generateGUID(), "INVENTARIO": Jexistencias }
      console.log(JCarga)
      const response = await apiService.post("CargarInventarioSala", JCarga);
      if (response) {
        const resultado = JSON.parse(response.datos_Generados);
        alert('¡Inventario cargado exitosamente!');
        window.location.reload();
      } else {
        alert('Error al cargar el inventario: ' + response.statusText);
      }
    } catch (error) {
      setMessage('Error de conexión: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="carga-inventario">
      <header className="header">
        <h1>Carga de Inventario</h1>
        <p>Carga tu archivo Excel para actualizar el inventario</p>
      </header>

      <div className='row'>
        <div className='col-6'>
          <main className="main-content">
            <div className="actions-section">
              <button onClick={descargarPlantilla} className="download-template-button">
                Descargar Plantilla
              </button>
            </div>

            <div className="dropzone-container">
              <div
                className={`dropzone ${isDragOver ? 'active' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById('file-input').click()}
              >
                <div className="icon">📁</div>
                <p>Arrastra y suelta tu archivo Excel aquí</p>
                <p>o</p>
                <button className="browse-button">Seleccionar archivo</button>
                <input
                  id="file-input"
                  type="file"
                  className="file-input"
                  accept=".xlsx, .xls"
                  onChange={handleFileSelect}
                />
              </div>

              {fileName && (
                <p style={{ marginTop: '10px' }}>
                  Archivo seleccionado: <strong>{fileName}</strong>
                </p>
              )}
            </div>

            {message && (
              <div className={`message ${message.includes('Error') ? 'error' : message.includes('éxito') ? 'success' : 'info'}`}>
                {message}
              </div>
            )}
          </main>
        </div>
        <div className='col-6'>

          <h2>Bitácora de Cargas</h2>
          <div className="bitacora-content">
            {bitacora.length > 0 ? (
              <table className="bitacora-table">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Sala</th>
                    <th>Productos</th>
                    <th>Unidades</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                  </tr>
                </thead>
                <tbody>
                  {bitacora.map((item, index) => (
                    <tr key={index}>
                      <td>{item.Usuario}</td>
                      <td>{item.CodigoSala}</td>
                      <td>{item.ProductosCargados}</td>
                      <td>{item.ProductosCargadosUnidades}</td>
                      <td>{Utils.formatDateOnly(item.FechaHoraEjecucion)}</td>
                      <td>{Utils.formatTimeOnly(item.FechaHoraEjecucion)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No hay registros de carga recientes</p>
            )}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          {data.length > 0 && (
            <div className="preview-section">
              <h2>Vista previa de los datos</h2>
              <p>Revisa que la información sea correcta antes de cargar el inventario</p>

              <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      {headers.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div>
                {user.usuario.length >= 6 && (
                  <div className='container' >
                    <label htmlFor="tienda-select" style={{ marginRight: '10px', fontWeight: 'bold' }}>
                      Seleccionar Sala:
                    </label>
                    <select
                      id="tienda-select"
                      value={SalaSeleccionada} // Asegúrate de tener este estado
                      onChange={(e) => setSalaSeleccionada(e.target.value)} // Y esta función
                      style={{
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        width: '100%'

                      }}
                    >
                      <option value="">-- Seleccione una sala --</option>
                      {tiendas.map((tienda) => (
                        <option key={tienda} value={tienda}>
                          {tienda}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={handleUpload}
                  disabled={loading}
                  className="upload-button"
                >
                  {loading ? 'Cargando...' : 'Cargar Inventario'}
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>

  );
}
export default CargaInventario;